import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';

import { DataMetric } from 'modules';
import * as ds from './dataService';



export type CompaniesSummaryCardProps = {};



export const FC = (props: CompaniesSummaryCardProps) => {
  const theme = useTheme();
  const { data, loading } = ds.useQuery();



  return (
    <Box
      bgcolor={theme.palette.primary.darker200}

      borderRadius='1rem'
      padding='1rem'
    >
      <Box
        display='flex'
        height='2rem'
        justifyContent='space-between'
        flexDirection='row'
      >
        <Stack
          flex='1 1 0'
          component='span'
          alignItems='center'
          direction='row'
          columnGap='.75rem'
        >
          <Typography
            variant='dataSummaryCardTitle'
            color={theme.palette.primary.main}
          >
            Company Data Updates
          </Typography>

        </Stack>

      </Box>
      <Box
        paddingTop='1rem'
        flexWrap='wrap'
        display='flex'
        justifyContent='space-evenly'
        columnGap='1rem'
        flexDirection='row'
      >
        {data?.metrics.map((metric, i) => (
          <DataMetric.FC
            key={i}
            loading={loading}
            name={metric.name}
            percentChangeMoM={metric.percentChangeMoM}
            value={metric.value}
          />
        ))}
      </Box>
    </Box>
  );
};
